export default function (doc) { // eslint-disable-line
  if (doc.isBroken) {
    return '/404';
  }

  if (doc.type === 'home') {
    return '/';
  }

  if (doc.data.path) {
    return doc.data.path;
  }

  return '/404';
}
